export const SET_DRIVE_BUTTON_STATUS = "SET_DRIVE_BUTTON_STATUS";
export const SET_DRIVE_BUTTON_SWITCHING_STATUS =
  "SET_DRIVE_BUTTON_SWITCHING_STATUS";
export const SET_THROTTLE_SPEED = "SET_THROTTLE_SPEED";
export const SET_DRIVING_STATUS = "SET_DRIVING_STATUS";
